import { AppRoute } from '@agentselly/immodossier-shared';
import { SignIn } from '@clerk/clerk-react';
import { useLinkProps } from '@tanstack/react-router';
import { useTheme } from '~/context/ThemeContext';
import { dark } from '@clerk/themes';

export function ClerkLoginWidget() {
  const { resolvedTheme } = useTheme();
  const { href: signUpUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_INDEX as any,
  });
  const { href: waitlistUrl } = useLinkProps({
    to: AppRoute.$LANG_$COMPANYID_PUBLIC_AUTH_WAITLIST as any,
  });

  return (
    <div className="h-full block overflow-x-hidden">
      <SignIn
        signUpUrl={signUpUrl}
        waitlistUrl={waitlistUrl}
        withSignUp={true}
        appearance={{
          baseTheme: resolvedTheme === 'dark' ? dark : undefined,
          elements: {
            rootBox: 'w-full h-full',
            cardBox: 'rounded-none shadow-none w-full h-full',
          },
        }}
      />
    </div>
  );
}
